/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { ServizioMensaMenuDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface DownloadMenuCittadinoRequestParams {
    idMenu: string;
    idStudente: string;
    gestioneMenseServizioId: string;
}

export interface ListMenuCittadinoRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
}


export interface MenuCittadinoServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Scarica il file di un menu visibile per uno studente del cittadino.
     * Audience CITTADINO. Scarica da S3 il file del menu indicato, ammesso solo se rientra tra i menu visibili per lo studente (ORDINARIO del servizio dello studente oppure EXTRA assegnato): lo stesso insieme della lista. Servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id (gate Pratica-accettata) + owner-check per-studente. Menu non visibile (di altro studente/servizio o inesistente) → 404 privacy-preserving.
     * @endpoint get /api/v1/cittadino/servizi/mensa/menu/{id_menu}/download
* @param requestParameters
     */
    downloadMenuCittadino(requestParameters: DownloadMenuCittadinoRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Lista dei menu visibili per uno studente del cittadino.
     * Audience CITTADINO. Ritorna il menu ORDINARIO del servizio dello studente indicato + l\&#39;eventuale menu EXTRA assegnato allo studente. Servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id (gate Pratica-accettata) + owner-check per-studente.
     * @endpoint get /api/v1/cittadino/servizi/mensa/menu
* @param requestParameters
     */
    listMenuCittadino(requestParameters: ListMenuCittadinoRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaMenuDTO>>;

}
